export default __webpack_public_path__ + "static/media/MagicCircle.d230df04.png";